// src/config/awsconfig.ts
const config = {
    stage : import.meta.env.VITE_STAGE,
    baseURL:import.meta.env.VITE_BASE_URL,
    cdnURL:import.meta.env.VITE_S3_URL,
  };
  
  export default config;
  